<template>

  <div>

    <vx-card>
      <div class="flex justify-between">

        <div class="self-end px-4 w-full">
          <label>Portfolio</label>
          <vs-select
            v-model="portfolioGuid"
            autocomplete
            class="w-full">
            <vs-select-item :key="index" :value="item.guid" :text="item.portfolioDate" v-for="(item, index) in portfolios" class="w-full"/>
          </vs-select>
        </div>

        <div class="self-end px-4 w-full">
          <label>Nome</label>
          <vs-select
            v-model="company"
            autocomplete
            class="w-full">
            <vs-select-item :key="index" :value="item" :text="item.name" v-for="(item, index) in companies" class="w-full"/>
          </vs-select>
        </div>

        <div class="self-end px-4 w-full">
          <label>Cnpj</label>
          <vs-select
            v-model="company"
            autocomplete
            class="w-full">
            <vs-select-item :key="index" :value="item" :text="(item.cnpjAlfa || item.cnpj) | formatCnpj" v-for="(item, index) in companies" class="w-full"/>
          </vs-select>
        </div>

      </div>
    </vx-card>

    <vx-card title="Limites de Exposição da Proposta Completo" class="mt-4">

      <div class="mt-6">
        <p class="font-semibold">{{company.name}}</p>
        <CceeChart :values="values" ref="chart"/>
      </div>

      <div class="mt-6" v-if="company.guid != null">

        <trader-report-table
          :operations="companyOperations"
          :months="months"
          @cliked="loadChart"
        />

      </div>

    </vx-card>

    <vx-card class="mt-4">

      <vs-row class="mt-4">
        <vs-col>
          <vs-button @click="downloadReport()">Download Relatório</vs-button>
        </vs-col>
      </vs-row>

      <div class="mt-4">
        <trader-report-table
          :operations="operations"
          :months="months"
          @cliked="loadChart"
        />

        <div class="my-5">
          <vs-pagination
            v-model="page"
            :total="totalPages">
          </vs-pagination>
        </div>

      </div>

    </vx-card>

  </div>

</template>

<script>
import axios from 'axios'
import LimitBarChart from "@/components/stats/LimitBarChart";
import CceeChart from "@/components/stats/CceeChart";
import portfolioList from "@/mixins/Portfolio";
import TraderReportTable from "@/components/TraderReportTable";
import moment from 'moment'

export default {
  name: "LimitList",
  mixins:[portfolioList],
  components: {
    LimitBarChart,
    CceeChart,
    TraderReportTable,
    moment
  },
  data () {
    return {
      months: [],
      values: [
        {
          label: '',
          data: [],
          borderWidth: 0,
          barPercentage: 1,
          categoryPercentage: 1,
        }
      ],
      companies: [],
      operations: [],
      companyOperations: [],
      company: {
        name: null,
        cnpj: null,
        guid: null
      },
      companyName: '',
      companyReport: [],
      serasa: '',
      page: 1,
      totalPages: 0,
    }
  },
  watch: {
    page () {
      this.loadTable()
    },
    portfolioGuid () {
      this.company.guid = null
      this.mountHeader()
      this.loadTable()
    },
    company () {
      this.loadChart(this.company)
    }
  },
  methods: {

    loadCompanies() {
      axios.get(`${process.env.VUE_APP_API}/api/v1/operation-report/companies`, {
        params: {
          portfolioGuid: this.portfolioGuid
        }
      })
      .then((response) => {
        this.companies = response.data
      })

    },

    mountHeader () {
      this.$vs.loading({color: this.$vs.theme.primary})
      let date = ''
      for (let idx in this.portfolios) {
        let portfolio = this.portfolios[idx]
        if (portfolio.guid === this.portfolioGuid) {
          date = portfolio.portfolioDate
        }
      }
      this.months = []
      date = moment(date).locale('pt')
      this.months.push(date.format('MMM YYYY'))
      for (let i = 0; i < 12; i++) {
        this.months.push(date.add(1, 'M').format('MMM YYYY'))
      }
      this.$vs.loading.close()
    },

    loadTable () {
      axios.get(`${process.env.VUE_APP_API}/api/v1/operation-report/`, {
        params: {
          page: this.page,
          portfolioGuid: this.portfolioGuid
        }
      })
        .then((response) => {
          this.operations = response.data.content
          this.totalPages = response.data.totalPages
        })
      .finally(()=>{
        this.loadCompanies()
      })
    },

    loadChart (company) {
      this.company.name = company.name
      this.company.guid = company.guid
      this.company.cnpj = company.cnpj
      this.companyName = company.name
      axios.get(`${process.env.VUE_APP_API}/api/v1/operation-report-chart/${this.portfolioGuid}/${company.guid}`)
        .then((response) => {
          this.values = response.data
        })
        .finally(() => {
          this.loadCompanyTable()
        })
    },

    loadCompanyTable () {
      axios.get(`${process.env.VUE_APP_API}/api/v1/operation-report/`, {
        params: {
          companyGuid: this.company.guid,
          page: this.page,
          portfolioGuid: this.portfolioGuid
        }
      })
        .then((response) => {
          this.companyOperations = response.data.content
        })
    },

    refine () {
      this.loadTable()
      this.operations = []
      this.values = [
        {
          label: '',
          data: [],
          borderWidth: 0,
          barPercentage: 1,
          categoryPercentage: 1,
        }
      ]
    },

    downloadReport () {
      axios.get(`${process.env.VUE_APP_API}/api/v1/operation-report/excel/report/${this.portfolioGuid}`,
        {
          responseType: 'blob'
        })
        .then((response) => {
          const url = window.URL.createObjectURL(new Blob([response.data]));
          const link = document.createElement('a');
          link.href = url;
          const filename = response.headers["x-suggested-filename"];
          link.setAttribute('download', filename);
          document.body.appendChild(link);
          link.click();
        })
    }


  }
}
</script>

<style scoped>

</style>
